<template>
  <div>
    <div class="level">
      <div class="level-item">&nbsp;</div>
      <div class="level-item statistics-title">{{ title }}</div>
      <div class="level-item distinct-toggler">
        <div>
          <input
            :id="id"
            type="checkbox"
            class="switch is-rtl is-small is-pulled-right"
            :checked="data.distinct === 'address'"
            :value="data.distinct === 'address'"
            @change="changeDistinct"
          />
          <label :for="id">Grupuj adresy IP</label>
        </div>
      </div>
    </div>
    <div class="statistics">
      <div class="control" :class="{ disabled: data.last }" @click="older">
        <icon name="fa-chevron-left" />
      </div>
      <div class="chart">
        <line-chart
          :chart-data="chartData"
          :options="options"
          :styles="{ position: 'relative' }"
        />
      </div>
      <div class="control" :class="{ disabled: data.first }" @click="younger">
        <icon name="fa-chevron-right" />
      </div>
    </div>
  </div>
</template>

<script>
import LineChart from "%admin/components/global/LineChart";

import { Icon } from "%helpers";

import { uuid } from "%utils/string";

const COLORS = {
  primary: [0, 164, 255],
  primary2: [0, 230, 255]
};

export default {
  name: "time-statistics",

  components: {
    LineChart,
    Icon
  },

  props: {
    data: {
      type: Object,
      default: () => ({
        content: []
      })
    },

    title: String,

    color: {
      type: String,
      default: "primary"
    }
  },

  data() {
    return {
      id: uuid(`distinct-switch-${this.title}`)
    };
  },

  computed: {
    chartData() {
      return {
        labels: this.data.content.map(x => x.key),
        datasets: [
          {
            data: this.data.content.map(x => x.total),
            borderColor: [`rgba(${COLORS[this.color].join(", ")}, 1)`],
            backgroundColor: [`rgba(${COLORS[this.color].join(", ")}, 0.4)`]
          }
        ]
      };
    },

    options() {
      return {
        legend: {
          display: false
        },

        responsive: true,
        maintainAspectRatio: false,

        scales: {
          xAxes: [
            {
              ticks: {
                autoSkip: false,
                maxRotation: 90,
                minRotation: 90
              }
            }
          ],

          yAxes: [
            {
              ticks: {
                callback(value) {
                  if (Number.isInteger(value)) {
                    return value;
                  }
                },
                stepSize: 1
              }
            }
          ]
        }
      };
    }
  },

  methods: {
    older() {
      if (!this.data.last) {
        this.goToPage(this.data.number + 1);
      }
    },

    younger() {
      if (!this.data.first) {
        this.goToPage(this.data.number - 1);
      }
    },

    goToPage(page) {
      this.$emit("request", { page });
    },

    changeDistinct(e) {
      this.$emit("request", {
        distinct: e.target.value !== "false" ? null : "address"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.level {
  margin-bottom: 0.5rem;

  .distinct-toggler {
    display: flex;
    justify-content: flex-end;
    padding-right: 1rem;
  }

  .statistics-title {
    font-weight: 700;
    font-size: 1.2rem;
  }
}

.statistics {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5rem;

  .chart {
    flex: 1;
    width: 100%;

    flex-grow: 1;
    min-height: 0;

    > div {
      position: relative;
      height: 100%;
    }
  }

  .control {
    color: $grey-light;
    cursor: pointer;
    font-size: 2rem;
    margin: 1rem;

    &:hover {
      color: $grey;
    }

    &.disabled {
      color: $grey-lighter;
      cursor: not-allowed;

      &:hover {
        color: $grey-lighter;
      }
    }
  }
}
</style>
